module.exports = __webpack_public_path__ + "static/media/PeoplePassengers.60968751.svg";